<template>
  <div>
    <el-row>
      <leaveTableContainer
        CustomTableArticle
        :columns="containerTableColumns"
        :serverUrl="containerServerUrl"
        :baseUrl="containerBaseUrl"
        ref="TableContainer"
      >
        <!-- <template v-slot:tools>
          <router-link :to="containerBaseUrl + '/add'">
            <el-button type="primary" icon="el-icon-circle-plus-outline">增加后台用户</el-button>
          </router-link>
        </template>-->

        <template v-slot:filter>
          <!-- <selectTableFilterStatus
            @DoChange="DoChangeStatus"
            showReview
            showDraft
            ref="selectTableFilterStatusRef"
          ></selectTableFilterStatus>-->
        </template>

        <!--  -->
        <template v-slot:table__footer__info>请假审核列表</template>
      </leaveTableContainer>

      <!-- <el-row>
          <p class="paragraph-content-small grey asset"><i class="el-icon-info"></i> 当前列表项的显示顺序，即是网站相关项目的显示顺序。</p>
      </el-row>-->
    </el-row>
  </div>
</template>

<script>

// @ is an alias to /src
import { BaseVue } from "@/mixin/index";
import { leaveTableContainer } from "@/core/table/";

export default {
  name: "leave-examine",
  
  mixins: [BaseVue],
  
  components: {
    leaveTableContainer
  },
  
  data() {
    return {
      // table 头
      containerTableColumns: [
        {
          prop: "name",
          label: "姓名",
        },
        {
          prop: "cdate",
          label: "请假日期",
        },
        {
          prop: "status",
          label: "状态",
        },
        {
          prop: "oderclassinfo",
          label: "排课信息",
        }, {
          prop: "reviewname",
          label: "审批人",
        },
      ],
      // 基础地址
      containerBaseUrl: "/leave",
      // api的基础地址
      containerServerUrl: "/api/manager/userleave"
    };
  }
};
</script>

<style scoped>
</style>

